// src/components/common/BackButton.jsx
import React from "react";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = ({ to, label = "Back", sx = {} }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to); // go to a fixed path
    } else {
      navigate(-1); // default: go back in history
    }
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleClick}
      sx={{
        textTransform: "none",
        borderRadius: 3,
        px: 2,
        py: 0.8,
        fontWeight: 500,
        bgcolor: "#edfef6",
        color: "#56C662",
        border: "2px solid #ddf3ea",
        "&:hover": { bgcolor: "rgba(5,150,105,0.08)" },
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default BackButton;
